export const bookingMainMixin = {
    data() {
        return {
            arrDate: [],
            dataTextFullMonth: "",
            logAttandance: [],
            logAbsent: [],
            logFlex: [],
            logWFH: [],
            logSeminar: [],
            logHolidayList: [],
            logBooking: [],
            listOfBooking: [],
            dateSelectView: "",
            loadingAll: false,
            isCalendarLoaded: false,
            isShowModalBookingInfo: false,
            isLoadedBookingInfo: true,
            isEmptyBooking: false,
            objData: {},
        };
    },
    methods: {
        formatMonth(val) {
            return val.toString().length == 1 ? "0" + val.toString() : val.toString();
        },
        getDayInFirst(month, year) {
            return new Date(year, month, 1).getDate().toString().length == 1
                ? "0" + new Date(year, month, 1).getDate()
                : new Date(year, month, 1).getDate();
        },
        getDayInLast(month, year) {
            return new Date(year, month, 0).getDate().toString().length == 1
                ? "0" + new Date(year, month, 0).getDate()
                : new Date(year, month, 0).getDate();
        },
        async sendDateTimeFormat(...args) {
            this.loadingAll = true;
            this.arrDate = [];
            if (args[0] !== "start") {
                // select month & year
                const d = new Date(args[0].a._d);
                let month = Number.parseInt(d.getMonth()) + Number.parseInt(1);
                let year = d.getFullYear();
                let formatMount = this.formatMonth(month);
                let startMonth =
                    year + "-" + formatMount + "-" + this.getDayInFirst(month, year);
                let endMonth =
                    year + "-" + formatMount + "-" + this.getDayInLast(month, year);
                // set data to calendar
                this.arrDate.push({
                    month: month,
                    year: year,
                    startDate: Number.parseInt(this.getDayInFirst(month, year)),
                    endDate: Number.parseInt(this.getDayInLast(month, year)),
                });
                // now datetime  booking
                await this.getBooking(
                    `${this.moment(startMonth).format("YYYY-MM-DD")}T00:00:00+07:00`,
                    `${this.moment(endMonth).format("YYYY-MM-DD")}T23:59:59+07:00`
                );
            } else {
                // now datetime
                const dnow = new Date();
                let monthNow = Number.parseInt(dnow.getMonth()) + Number.parseInt(1);
                let yearNow = dnow.getFullYear();
                let formatMountNow = this.formatMonth(monthNow);

                let startMonthNow =
                    yearNow +
                    "-" +
                    formatMountNow +
                    "-" +
                    this.getDayInFirst(monthNow, yearNow);
                let endMonthNow =
                    yearNow +
                    "-" +
                    formatMountNow +
                    "-" +
                    this.getDayInLast(monthNow, yearNow);
                // set data to calendar
                this.arrDate.push({
                    month: monthNow,
                    year: yearNow,
                    startDate: Number.parseInt(this.getDayInFirst(monthNow, yearNow)),
                    endDate: Number.parseInt(this.getDayInLast(monthNow, yearNow)),
                });
                // now get Booking
                await this.getBooking(
                    // this.moment(startMonthNow).format("YYYY-MM-DD"),
                    // this.moment(endMonthNow).format("YYYY-MM-DD")
                    `${this.moment(startMonthNow).format("YYYY-MM-DD")}T00:00:00+07:00`,
                    `${this.moment(endMonthNow).format("YYYY-MM-DD")}T23:59:59+07:00`
                );
            }
            this.loadingAll = false;
        },
        openNotification(args) {
            this.$notification.open({
                style: {
                    backgroundColor: args.backgroundColor,
                    color: args.color,
                },
                message: function (h) {
                    return h("div", [h("strong", { class: "" }, args.title)]);
                },
                description: args.msg,
            });
        },
        viewBooking(...args) {
            let dateTimeSelected = args[0];
            this.isShowModalBookingInfo = true;
            this.isEmptyBooking = false;
            this.isLoadedBookingInfo = false;
            if (typeof this.resetFormData === 'function') {
                this.resetFormData();
            } else {
                this.objData = {};
            }
            this.dateSelectView = dateTimeSelected;
            this.getDetailBooking(dateTimeSelected);
        },
    },
};
